import { Directive, Output, HostListener, EventEmitter } from '@angular/core';

// <div mouseWheel (mouseWheelUp)="mouseWheelUpFunc(event)" (mouseWheelDown)="mouseWheelDownFunc(event)"></div>
@Directive({ selector: '[appMouseWheel]' })
export class MouseWheelDirective {
    @Output() mouseWheelUp = new EventEmitter();
    @Output() mouseWheelDown = new EventEmitter();

    @HostListener('mousewheel', ['$event']) onMouseWheelChrome(event: any) {
        this.mouseWheelFunc(event);
    }

    @HostListener('DOMMouseScroll', ['$event']) onMouseWheelFirefox(event: any) {
        this.mouseWheelFunc(event);
    }

    @HostListener('onmousewheel', ['$event']) onMouseWheelIE(event: any) {
        this.mouseWheelFunc(event);
    }

    mouseWheelFunc(event: any) {
        const myEvent = window.event || event; // old IE support
        const delta = Math.max(-1, Math.min(1, (myEvent.wheelDelta || -myEvent.detail)));
        if (delta > 0) {
            this.mouseWheelUp.emit(myEvent);
        } else if (delta < 0) {
            this.mouseWheelDown.emit(myEvent);
        }
        // for IE
        event.returnValue = false;
        // for Chrome and Firefox
        if (myEvent.preventDefault) {
            myEvent.preventDefault();
        }
    }
}
